import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { SalesforceMarketingCloudObjectDataset } from 'app/model/dataset/salesforce-marketing-cloud-object.dataset';
import { Metamodel } from 'app/model/base/model';
import { SalesforceMarketingCloudLinkedService } from 'app/model/linkedservice/salesforce-marketing-cloud.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const salesforceMarketingCloudObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(SalesforceMarketingCloudObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.SalesforceMarketingCloud_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(SalesforceMarketingCloudLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Salesforce'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
